import styled from 'styled-components';

import Container from '../Container.styled';

type HeroPropsT = {
  isHeroVisible: boolean;
};

export const HeroWrapperStyled = styled.section<HeroPropsT>`
  ${({ isHeroVisible }) => `
     position: relative;
     height: 120px;
   
   ${
     !isHeroVisible &&
     `
      height: auto;

     ${ControlsWrapperStyled} {
      position: static;
      padding-top: 0;
      padding-bottom: 0;
     }
   `
   }
  `}
`;

export const ImgStyled = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const ControlsWrapperStyled = styled(Container)`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding-bottom: 0;

  display: flex;
  justify-content: flex-end;
  gap: 5px;

  & > div {
    width: 105px;
  }

  ${({ theme }) => `
    ${theme.devices.mobile} {
      right: 20px;
    }
  `}

  .react-select__control {
    border: none;
    border-radius: 2px 2px 0px 0px;
    box-shadow: none;
    height: 32px;
    min-height: 32px;
    padding: 5px;
  }

  .react-select__menu {
    margin-top: 0;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 2px 0px;
  }

  .react-select__option,
  .react-select__value-container {
    font-size: ${({ theme }) => theme.fontSizes.xSmall};
  }

  .react-select__dropdown-indicator {
    width: 9px;
  }
`;
